import script from "./tooltipFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./tooltipFrame.vue?vue&type=script&setup=true&lang=js"

import "./tooltipFrame.vue?vue&type=style&index=0&id=6adf2eac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6adf2eac"]])

export default __exports__